import z from 'zod';

export const newsInsightsTypeaheadValueSchema = z.object({
  href: z.string(),
  title: z.string(),
  type: z.union([z.literal('link'), z.literal('query')]),
});

export type NewsInsightsTypeaheadValue = z.infer<typeof newsInsightsTypeaheadValueSchema>;
